
    import * as React from 'react';

    const ChevronDown20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" style={svgStyle}><path d="M2.11 6.225l-.887.883L9.927 15.83l8.845-8.723-.877-.89-7.96 7.85z" /></svg>
        </div>
      );
    };

    ChevronDown20.displayName = 'ChevronDown20';

    export default ChevronDown20;
  